import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import "select2"

export default class extends Controller {
  static values = { placeholder: String, max: Number }

  connect() {
    if (!this.element.id) this.element.id = `select2_${Math.random().toString(36).slice(2)}`
    $(this.element).select2({
      width: "100%",
      placeholder: this.placeholderValue || "",
      closeOnSelect: false,
      allowClear: true
    })
    const max = this.hasMaxValue ? this.maxValue : null
    if (max) {
      $(this.element).on("select2:select", () => {
        const selected = $(this.element).val() || []
        if (selected.length > max) {
          const next = selected.slice(0, max)
          $(this.element).val(next).trigger("change")
        }
      })
    }
  }

  disconnect() {
    if ($(this.element).data("select2")) $(this.element).select2("destroy")
  }
}
